import { mapActions, mapGetters } from 'vuex';
import Card from '../../components/Card/Card';
import PageTitle from '../../components/Pagetitle/Pagetitle';
import Table from '../../components/Table/Table';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import Input from '../../components/Input/Input';
import Label from '../../components/Label/Label';
import ThemesTable from '@/components/tables/ThemesTable';
import PlaceholderTable from '@/components/tables/PlaceholderTable/PlaceholderTable';
import Context from '@/models/Context';
import Topic from '@/models/strategy/Topic';

export default {
  name: 'themes',
  components: {
    ThemesTable,
    PlaceholderTable,
    PageTitle,
    Card
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    teamTopics: function() {
      if (!this.isLoading) {
        return Topic.query()
          .where(topic => {
            return topic.isTopLevel === true;
          })
          .all();
      } else {
        return null;
      }
    },

    isLoading: function() {
      return this._isLoading();
    }
  },
  beforeMount() {
    this._topics();
    this._groups();
  },
  mounted() {},
  methods: {
    ...mapActions({
      _topics: 'entities/topics/findForTeam',
      _groups: 'entities/groups/findForTeam'
    }),
    ...mapGetters({
      _isLoading: 'isLoading'
    })
  }
};
